<aside>
  @if (imageOnLoginAside) {
  <app-image name="signin" [responsive]="true"></app-image>
  } @else {
  <div class="aside-container">
    <h3>{{ 'aside.header' | translate: locale.language }}</h3>
    <nz-divider></nz-divider>
    <div [innerHTML]="'aside.text'| translate: locale.language"></div>
  </div>
  }
</aside>
